




import Vue from 'vue'
const ProvinceName = Vue.extend({
  name: 'ProvinceName',
  props: {
    provinceCode: {
      type: [String, Number],
      required: true,
      validator: (value: string | number) => {
        const parsedValue = '' + value
        return ['15', '32', '27', '36'].indexOf(parsedValue) !== -1
      }
    }
  }
})
export default ProvinceName
